import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Modal, Input, Textarea, Select } from "./Leads";
import { Plus, Calendar } from "lucide-react";
import { toast } from "sonner";

export default function MOM() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    project_id: "", meeting_type: "Client", meeting_date: new Date().toISOString().slice(0, 10),
    agenda: "", minutes: "", action_items_raw: "",
  });

  const load = async () => {
    const [m, p] = await Promise.all([api.get("/mom"), api.get("/projects")]);
    setItems(m.data);
    setProjects(p.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/mom", {
        ...form,
        action_items: form.action_items_raw.split("\n").map((s) => s.trim()).filter(Boolean),
      });
      toast.success("MOM saved");
      setOpen(false);
      load();
    } catch { toast.error("Failed"); }
  };

  const projName = (id) => projects.find((p) => p.id === id)?.project_name || "—";

  return (
    <div className="space-y-6 animate-fade-up">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-emerald-700 font-semibold mb-2">Meetings</p>
          <h1 className="text-4xl font-bold tracking-tight text-stone-900" style={{ fontFamily: "Bricolage Grotesque" }}>Minutes of Meeting</h1>
        </div>
        <button onClick={() => setOpen(true)} data-testid="new-mom-btn" className="flex items-center gap-2 bg-stone-900 text-white px-4 py-2.5 rounded-lg text-sm font-medium">
          <Plus className="w-4 h-4" /> New MOM
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((m) => (
          <div key={m.id} data-testid={`mom-${m.id}`} className="bg-white border border-stone-200 rounded-xl p-5">
            <div className="flex items-start justify-between mb-2">
              <div>
                <span className="text-[10px] uppercase tracking-wider bg-emerald-100 text-emerald-800 px-2 py-1 rounded-full font-medium">{m.meeting_type}</span>
                <div className="text-xs text-stone-500 mt-2 flex items-center gap-1"><Calendar className="w-3 h-3" />{m.meeting_date}</div>
              </div>
              <div className="text-xs text-stone-500">{projName(m.project_id)}</div>
            </div>
            <div className="font-semibold text-stone-900 mt-3">{m.agenda}</div>
            <p className="text-sm text-stone-600 mt-2">{m.minutes}</p>
            {m.action_items && m.action_items.length > 0 && (
              <div className="mt-3 pt-3 border-t border-stone-100">
                <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold mb-2">Action Items</div>
                <ul className="space-y-1">
                  {m.action_items.map((a, i) => (
                    <li key={i} className="text-xs text-stone-700 flex items-start gap-2">
                      <span className="text-emerald-600 mt-0.5">▸</span><span>{a}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-stone-400 py-12">No meetings recorded</div>}
      </div>

      {open && (
        <Modal title="New MOM" onClose={() => setOpen(false)}>
          <form onSubmit={submit} className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <Select label="Meeting Type" value={form.meeting_type} onChange={(v) => setForm({ ...form, meeting_type: v })} options={["Client", "SEAC", "SEIAA", "MPCB", "Internal"]} testid="mom-type" />
              <Input label="Meeting Date" type="date" value={form.meeting_date} onChange={(v) => setForm({ ...form, meeting_date: v })} required testid="mom-date" />
            </div>
            <Select label="Project" value={form.project_id} onChange={(v) => setForm({ ...form, project_id: v })} options={[{ value: "", label: "—" }, ...projects.map((p) => ({ value: p.id, label: p.project_name }))]} testid="mom-project" />
            <Input label="Agenda" value={form.agenda} onChange={(v) => setForm({ ...form, agenda: v })} required testid="mom-agenda" />
            <Textarea label="Minutes" value={form.minutes} onChange={(v) => setForm({ ...form, minutes: v })} testid="mom-minutes" />
            <Textarea label="Action Items (one per line)" value={form.action_items_raw} onChange={(v) => setForm({ ...form, action_items_raw: v })} testid="mom-actions" />
            <button type="submit" data-testid="mom-submit" className="w-full bg-emerald-700 text-white py-2.5 rounded-lg font-medium">Save MOM</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
